<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="profile-title">
      {{ $t("app.modules.notifications.title") }}
    </h4>

    <div class="col-6">
      <n-button
        type="primary"
        @click.native="
          readAll()
        "
        >Mark as read
      </n-button>
    </div>

    <!--  
    <div class="col-12" style="text-align: center">
      <n-button native-type="submit" type="primary" style="font-size: 1.2rem">{{
        $t("app.general.send")
      }}</n-button>
    </div> -->

    <div class="row col-12">
      <div
        class="col-md-12"
        v-for="item in queriedData"
        :key="item.idHistorial"
      >
        <a
          :href="item.enlace.replace('/admin', '')"
          style="color: black"
          @click="read(item.idHistorial)"
          v-if="item.tipoElemento == constTiposNotificacionesPush.PEDIDO"
        >
          <card class="not-label">
            <div class="col-12">{{ item.fecha }}</div>
            <div class="row">
              <div class="col-10">{{ item.contenido }}</div>
              <div class="col-2 text-right">
                <template v-if="item.leida">
                  <i class="now-ui-icons ui-1_check"></i>
                </template>
              </div>
            </div>
          </card>
        </a>
        <a
          href="javascript:function(){return false;}"
          style="color: black"
          @click="showTracking(item.enlace, item.contenido, item.idHistorial)"
          v-else-if="
            item.tipoElemento == constTiposNotificacionesPush.STATUSTRACKING
          "
        >
          <card class="not-label">
            <div class="col-12">{{ item.fecha }}</div>
            <div class="row">
              <div class="col-10">{{ item.contenido }}</div>
              <div class="col-2 text-right">
                <template v-if="item.leida">
                  <i class="now-ui-icons ui-1_check"></i>
                </template>
              </div>
            </div>
          </card>
        </a>
        <div v-else>
          <card class="not-label">
            <div class="col-12">{{ item.fecha }}</div>
            <div class="row">
              <div class="col-10">{{ item.contenido }}</div>
              <div class="col-2 text-right">
                <template v-if="item.leida">
                  <i class="now-ui-icons ui-1_check"></i>
                </template>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>

    <div
      slot="footer"
      class="
        col-12
        d-flex
        justify-content-center justify-content-sm-between
        flex-wrap
      "
    >
      <div class="">
        <p class="card-category">
          {{ $t("app.pagination.showing") }} {{ from + 1 }}
          {{ $t("app.pagination.of") }} {{ to }} {{ $t("app.pagination.of") }}
          {{ total }}
          {{ $t("app.pagination.records") }}
        </p>
      </div>

      <n-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </n-pagination>
    </div>
  </modal>
</template>

<script>
import ConstTiposNotificacionesPush from "@/models/notificaciones/ConstTiposNotificacionesPush";
import { mapMutations } from "vuex";
export default {
  components: {},
  computed: {
    queriedData() {
      let result = this.tableData;

      // Search by term
      result =
        this.searchQuery.length > 0
          ? result.filter((p) =>
              p.contenido.toLowerCase().includes(this.searchQuery.toLowerCase())
            )
          : result;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      searchQuery: "",
      tableData: [],
      searchedData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      modals: {
        classic: false,
        notice: false,
        mini: false,
      },
      constTiposNotificacionesPush: new ConstTiposNotificacionesPush(),
      pedido: {},
      detalle: {},
      notificacion: {},
    };
  },
  created() {
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  mounted() {
    EventBus.$on("show-notification", async () => {
      this.modals.classic = true;
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      await this.getItems();
      this.$swal.close();
    });
  },
  methods: {
    ...mapMutations({
      setOrder: "SET_ORDER",
      setDetail: "SET_DETAIL",
      setNotCount: "SET_NOT_COUNT",
    }),
    async readAll() {

      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
      };

      await this.$http
        .post(route("NotificacionWeb/postNotificacionLeida"), params)
        .then(
          (response) => {
            if (response.body.code === 200) {
              this.getNotCount();
            } else {
              console.log(response.body);
              // this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.error(error);
            // this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        );

      this.$swal.close();  
      this.modals.classic = false;
    },
    async read(id) {
      const params = {
        Id: id,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
      };

      await this.$http
        .post(route("NotificacionWeb/postNotificacionLeida"), params)
        .then(
          (response) => {
            if (response.body.code === 200) {
              this.getNotCount();
            } else {
              console.log(response.body);
              // this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.error(error);
            // this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        );

      this.modals.classic = false;
    },
    async getItems() {
      const params = {
        Id: this.$store.state.user.idUsuario,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
      };

      await this.$http
        .post(route("NotificacionWeb/getNotificacionesWebHistorial"), params)
        .then(
          (response) => {
            if (response.body.code === 200) {
              console.log(response.body.historial);
              this.tableData = response.body.historial.sort((a, b) =>
                a.idHistorial < b.idHistorial ? 1 : -1
              );
            } else {
              console.log(response.body);
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.error(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        );
    },
    async getNotCount() {
      const params = {
        Id: this.$store.state.user.idUsuario,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
      };

      await this.$http
        .post(route("NotificacionWeb/getNotificacionesWebConteo"), params)
        .then(
          (response) => {
            if (response.body.code === 200) {
              // this.$store.state.not_count = response.body.Id
              this.setNotCount(response.body.id);
            } else {
              console.log(response.body);
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.error(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        );
    },
    async showTracking(enlace, contenido, historial) {
      await this.getNotDetail(historial);
      // console.log(this.notificacion);
      var enl = enlace.split("/");
      var idPedido = enl[3];
      var idPartida = this.notificacion.idElemento;
      // console.log("idPedido", idPedido);
      // console.log("idPartida", idPartida);
      await this.getOrder(idPedido);
      await this.getDetail(idPartida);
      this.setOrder(this.pedido);
      this.setDetail(this.detalle);
      await this.read(historial);
      // console.log(this.$route);
      if (this.$route.name == "Tracking partida web") {
        location.reload();
      } else {
        this.$router.push({ name: "Tracking partida web" });
      }
      /**/
    },
    async getOrder(id) {
      const params = {
        id: parseInt(id),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http.post(route("Pedidos/getPedidoWeb"), params).then(
        async (response) => {
          if (response.body.code === 200) {
            this.pedido = response.body.pedido;
            // console.log(this.pedido);
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(response.body.message);
          }
        },
        (error) => {
          this.notifyMessage("danger", this.$t("app.promps.error"));
          console.error(error);
        }
      );
    },
    async getDetail(id) {
      const params = {
        id: parseInt(id),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("Pedidos/getPedidoDetalleWebId"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              if (response.body.detalles.length > 0) {
                this.detalle = response.body.detalles[0];
                console.log(this.detalle);
              }
            } else {
              console.log(response.body);
              // this.processError(response.body)
            }
          },
          (error) => {
            console.error(error);
            // this.processError(error)
          }
        );
    },
    async getNotDetail(id) {
      const params = {
        id: parseInt(id),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("NotificacionWeb/getNotificacionWeb"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              if (response.body.historial.length > 0) {
                this.notificacion = response.body.historial[0];
                console.log(this.notificacion);
              }
            } else {
              console.log(response.body);
              // this.processError(response.body)
            }
          },
          (error) => {
            console.error(error);
            // this.processError(error)
          }
        );
    },
  },
  watch: {},
};
</script>

<style scoped>
.profile-title {
  background-color: #e31d1a;
  color: white;
  text-align: center;
  width: 100%;
}

.profile-img {
  width: 50%;
  height: auto;
}

.not-label {
  color: black;
}
</style>
